import { Steps } from 'antd';
import React from 'react';

import { WrapSketchStep } from './index.styled';

const Step = Steps.Step;

const SketchStep = () => {
  return (
    <WrapSketchStep>
      <Steps size="small" direction="vertical">
        <Step
          title="주문케익확인"
          description="주문하신 내용중 스케치가 필요한부분이 모두표시됩니다. 주문상품이 맞는지 확인해주세요."
          status="wait"
          style={{ fontSize: "13px" }}
        />
        <Step
          title="디자인편집"
          description="내용변경하기 클릭후 원하시는 내용으로 꾸며주세요"
        />
        <Step
          title="디자인확정"
          description="최종검수후 디자인별로 각각 확정버튼을 클릭하여 완료해주세요"
        />
      </Steps>
    </WrapSketchStep>
  );
};

export default SketchStep;



// WEBPACK FOOTER //
// ./src/components/sketchStep/index.tsx